import { useEffect, useRef } from 'react';
import Modal from 'react-bootstrap/Modal';
import { RxCross1 } from 'react-icons/rx';
import SiteToast from './SiteToast';

function SiteModal({
  modalFooter = '',
  modalTitle = '',
  modalHeader = false,
  isFromLocation = false,
  shouldScrollToTop = false,
  isCenteredTitle = false,
  showModal,
  hideModal,
  classes,
  children,
  errorMsg,
  wrapperClass,
  size,
  analyticSetting = false,
  showToast,
  userMsg,
  fullscreen = false,
  closeCallback = () => {},
  ...props
}) {
  const modalBodyRef = useRef();

  useEffect(() => {
    return () => {
      typeof closeCallback === 'function' && closeCallback();
      children = null;
    };
  }, []);

  useEffect(() => {
    const modalBody = modalBodyRef.current;
    // Ensure the modal body is scrolled to the top by default
    if (modalBody && shouldScrollToTop) {
      setTimeout(() => {
        if (modalBody && shouldScrollToTop) {
          modalBody.scrollTop = 0;
        }
      }, 50);
    }
  }, [shouldScrollToTop]);

  return (
    <div className={`modal-wrapper${wrapperClass ? ' ' + wrapperClass : ''}`}>
      <Modal
        fullscreen={fullscreen}
        show={showModal?.toString() === 'true' ? showModal : false}
        onHide={hideModal}
        size={size || 'md'}
        aria-labelledby="contained-modal-title-vcenter"
        centered
        backdrop="static"
        keyboard={false}
        className={classes}
      >
        {!modalHeader && (
          <Modal.Header>
            <Modal.Title
              className={`modal-title ${
                isFromLocation ? ' location-font' : ''
              } ${isCenteredTitle ? 'centered-title' : ''}`}
            >
              {modalTitle}
            </Modal.Title>
            <RxCross1
              className="site-modal-close"
              size={20}
              onClick={hideModal}
            />
          </Modal.Header>
        )}
        {userMsg ? (
          <SiteToast
            customCss="manage-tags-toast"
            position="top-end"
            show={showToast}
            title="Error!"
            body={userMsg}
            delay={5000}
          />
        ) : null}
        <Modal.Body
          ref={modalBodyRef}
          className={analyticSetting && 'text-center'}
        >
          {children}
        </Modal.Body>
        {modalFooter && <Modal.Footer>{modalFooter}</Modal.Footer>}
      </Modal>
    </div>
  );
}

export default SiteModal;
